export default __webpack_public_path__ + "static/media/parkShort.9d5c39e2.png";